import drawing1 from '../images/drawings/01-tekening70x100cm.jpeg';
import drawing2 from '../images/drawings/02-tekening70x100cm.jpeg';
import drawing3 from '../images/drawings/03-tekening-70x100cm.jpeg';
import drawing4 from '../images/drawings/04-ZT-20x30.jpeg';
import drawing5 from '../images/drawings/05-ZT-20x30.jpeg';
import drawing6 from '../images/drawings/06-ZT-20x30.jpeg';
import drawing7 from '../images/drawings/07-ZT-20x30.jpeg';
import drawing8 from '../images/drawings/08-ZT20x30.jpeg';
import drawing9 from '../images/drawings/09-ZT20x30.jpeg';
import drawing10 from '../images/drawings/010-ZT20x30.jpeg';
import drawing11 from '../images/drawings/011-ZT20x30.jpeg';
import drawing12 from '../images/drawings/012-ZT20x30.jpeg';
import drawing13 from '../images/drawings/013-ZT20x30.jpeg';
import drawing14 from '../images/drawings/014-ZT20x30.jpeg';
import drawing15 from '../images/drawings/015-ZT 20x30.jpeg';
import drawing16 from '../images/drawings/016-ZT-20x30.jpeg';
import drawing17 from '../images/drawings/017-ZT20x30.jpeg';
import drawing18 from '../images/drawings/018-ZT20x30.jpeg';
import drawing19 from '../images/drawings/019-ZT20x30.jpeg';
import drawing20 from '../images/drawings/020-ZT20x30.jpeg';
import drawing21 from '../images/drawings/021-ZT20x30.jpeg';
import drawing22 from '../images/drawings/022-ZT20x30.jpeg';
import drawing23 from '../images/drawings/023-ZT20x30.jpeg';
import drawing24 from '../images/drawings/024-ZT20x30.jpeg';
import drawing25 from '../images/drawings/025-ZT20x30.jpeg';
import drawing26 from '../images/drawings/026-ZT20x30.jpeg';
import drawing27 from '../images/drawings/027-ZT20x30.jpeg';
import drawing28 from '../images/drawings/028-ZT20x30.jpeg';
import drawing29 from '../images/drawings/029-ZT20x30.jpeg';
import drawing30 from '../images/drawings/030-ZT20x30.jpeg';
// import drawing31 from "../images/drawings/035-pastel.jpeg";
// import drawing32 from "../images/drawings/36.jpeg";
import drawing33 from '../images/drawings/37.jpeg';
// import drawing34 from "../images/drawings/38.jpeg";
import drawing35 from '../images/drawings/39.jpeg';
import drawing36 from '../images/drawings/40.jpeg';
import drawing37 from '../images/drawings/41.jpeg';
import drawing38 from '../images/drawings/43.jpeg';
// import drawing39 from "../images/drawings/44.jpeg";
import drawing40 from '../images/drawings/45.jpeg';
import drawing41 from '../images/drawings/46.jpeg';
import drawing42 from '../images/drawings/47.jpeg';
import drawing43 from '../images/drawings/48.jpeg';
import drawing45 from '../images/drawings/1IMG_5217.jpg';
import drawing46 from '../images/drawings/2IMG_5216.jpg';
import drawing47 from '../images/drawings/4IMG_1019.jpg';
import drawing48 from '../images/drawings/5IMG_1020.jpg';
import drawing49 from '../images/drawings/8IMG_5205.jpeg';
import drawing50 from '../images/drawings/9IMG_5183.jpeg';
import drawing51 from '../images/drawings/10IMG_5176.jpeg';
import drawing52 from '../images/drawings/11IMG_5181.jpeg';
import drawing53 from '../images/drawings/12IMG_5184.jpeg';
import drawing54 from '../images/drawings/13IMG_5187.jpeg';
import drawing55 from '../images/drawings/14IMG_5190.jpeg';
import drawing56 from '../images/drawings/15IMG_5191.jpeg';
import drawing57 from '../images/drawings/16IMG_5194.jpeg';
import drawing58 from '../images/drawings/17IMG_5195.jpeg';
import drawing59 from '../images/drawings/19IMG_5204.jpeg';
import drawing60 from '../images/drawings/20IMG_5200.jpeg';
import drawing61 from '../images/drawings/21IMG_5202.jpeg';
import drawing62 from '../images/drawings/22IMG_5197.jpeg';
import drawing63 from '../images/drawings/23IMG_5199.jpeg';
import drawing64 from '../images/drawings/24IMG_5218.jpg';
import drawing65 from '../images/drawings/26IMG_5220.jpeg';
import drawing66 from '../images/drawings/30IMG_5163.jpg';
import drawing67 from '../images/drawings/31IMG_5162.jpg';
import drawing68 from '../images/drawings/32IMG_5160.jpg';
import drawing69 from '../images/drawings/33IMG_5164.jpg';
import drawing70 from '../images/drawings/36IMG_1487.jpeg';
import drawing71 from '../images/drawings/38DSC_0123.jpeg';
import drawing72 from '../images/drawings/39IMG_5166.jpg';
import drawing73 from '../images/drawings/40DSC_0121.jpeg';
import drawing74 from '../images/drawings/new-images-14-feb-2025/1.jpg';
import drawing75 from '../images/drawings/new-images-14-feb-2025/2.jpeg';
import drawing76 from '../images/drawings/new-images-14-feb-2025/3.jpg';
import drawing77 from '../images/drawings/new-images-14-feb-2025/4.jpg';
import drawing78 from '../images/drawings/new-images-14-feb-2025/5.jpg';
import drawing79 from '../images/drawings/new-images-14-feb-2025/6.jpg';
import drawing80 from '../images/drawings/new-images-14-feb-2025/7.jpg';
import drawing81 from '../images/drawings/new-images-14-feb-2025/8.jpg';
import drawing82 from '../images/drawings/new-images-14-feb-2025/9.jpeg';
import drawing83 from '../images/drawings/new-images-14-feb-2025/10.jpeg';
import drawing84 from '../images/drawings/new-images-14-feb-2025/11.jpeg';
import drawing85 from '../images/drawings/new-images-14-feb-2025/12.jpeg';
import drawing86 from '../images/drawings/new-images-14-feb-2025/13.jpeg';
import drawing87 from '../images/drawings/new-images-14-feb-2025/14.jpeg';
import drawing88 from '../images/drawings/new-images-14-feb-2025/15.jpeg';
import drawing89 from '../images/drawings/new-images-14-feb-2025/16.jpg';
import drawing90 from '../images/drawings/new-images-14-feb-2025/17.jpg';

export type Drawing = {
  imageSRC: string | any;
  material: string;
  size: string;
};

export const Drawings: Drawing[] = [
  {
    imageSRC: drawing74,
    material: 'Color pencil',
    size: '70x100',
  },
  {
    imageSRC: drawing75,
    material: 'Color pencil',
    size: '147x50',
  },
  {
    imageSRC: drawing76,
    material: 'Color pencil',
    size: '50x65',
  },
  {
    imageSRC: drawing77,
    material: 'Color pencil',
    size: '50x65',
  },
  {
    imageSRC: drawing78,
    material: 'Color pencil',
    size: '50x65',
  },
  {
    imageSRC: drawing79,
    material: 'Color pencil',
    size: '50x70',
  },
  {
    imageSRC: drawing80,
    material: 'Color pencil',
    size: '50x70',
  },
  {
    imageSRC: drawing81,
    material: 'Color pencil',
    size: '70x50',
  },
  {
    imageSRC: drawing82,
    material: 'Color pencil, pastel',
    size: '50x70',
  },
  {
    imageSRC: drawing83,
    material: 'Aquarelle',
    size: '30x20',
  },
  {
    imageSRC: drawing84,
    material: 'Aquarelle',
    size: '24x32',
  },
  {
    imageSRC: drawing85,
    material: 'Aquarelle',
    size: '32x24',
  },
  {
    imageSRC: drawing86,
    material: 'Color pencil, aquarelle',
    size: '24x32',
  },
  {
    imageSRC: drawing87,
    material: 'Aquarelle acrylic',
    size: '24x32',
  },
  {
    imageSRC: drawing88,
    material: 'Aquarelle acrylic, color pencil',
    size: '24x32',
  },
  {
    imageSRC: drawing89,
    material: 'Ceramics on a board',
    size: '38x25',
  },
  {
    imageSRC: drawing90,
    material: 'Aquarelle, color pencil',
    size: '150x50',
  },

  {
    imageSRC: drawing45,
    material: 'Colored pencils',
    size: '42x30',
  },
  {
    imageSRC: drawing46,
    material: 'Colored pencils',
    size: '42x30',
  },
  {
    imageSRC: drawing49,
    material: 'Pastel on paper',
    size: '50x65',
  },
  {
    imageSRC: drawing50,
    material: 'Pastel on paper',
    size: '50x65',
  },
  {
    imageSRC: drawing51,
    material: 'Pastel on paper',
    size: '50x65',
  },
  {
    imageSRC: drawing52,
    material: 'Pastel on paper',
    size: '50x65',
  },
  {
    imageSRC: drawing53,
    material: 'Pastel on paper',
    size: '50x65',
  },
  {
    imageSRC: drawing54,
    material: 'Pastel on paper',
    size: '50x65',
  },
  {
    imageSRC: drawing55,
    material: 'Pastel on paper',
    size: '65x50',
  },
  {
    imageSRC: drawing56,
    material: 'Pastel on paper',
    size: '65x50',
  },
  {
    imageSRC: drawing57,
    material: 'Pastel on paper',
    size: '65x50',
  },
  {
    imageSRC: drawing58,
    material: 'Pastel on paper',
    size: '65x50',
  },
  {
    imageSRC: drawing59,
    material: 'Pastel on paper',
    size: '50x65',
  },
  {
    imageSRC: drawing62,
    material: 'Pastel on paper',
    size: '65x50',
  },
  {
    imageSRC: drawing63,
    material: 'Pastel on paper',
    size: '65x50',
  },
  {
    imageSRC: drawing64,
    material: 'Pastel on paper',
    size: '42x30',
  },
  {
    imageSRC: drawing65,
    material: 'Pastel on paper',
    size: '42x30',
  },
  {
    imageSRC: drawing67,
    material: 'Colored pencils',
    size: '35x25',
  },
  {
    imageSRC: drawing68,
    material: 'Colored pencils',
    size: '35x25',
  },
  {
    imageSRC: drawing69,
    material: 'Colored pencils',
    size: '35x25',
  },
  {
    imageSRC: drawing70,
    material: 'Colored pencils',
    size: '35x25',
  },
  {
    imageSRC: drawing72,
    material: 'Colored pencils',
    size: '35x25',
  },
  {
    imageSRC: drawing73,
    material: 'Colored pencils',
    size: '35x25',
  },
  {
    imageSRC: drawing1,
    material: 'Color pencil',
    size: '70x100',
  },
  {
    imageSRC: drawing2,
    material: 'Color pencil',
    size: '70x100',
  },
  {
    imageSRC: drawing3,
    material: 'Color pencil',
    size: '70x100',
  },
  {
    imageSRC: drawing4,
    material: 'Color pencil',
    size: '20x30',
  },
  {
    imageSRC: drawing5,
    material: 'Color pencil',
    size: '20x30',
  },
  {
    imageSRC: drawing6,
    material: 'Color pencil',
    size: '20x30',
  },
  {
    imageSRC: drawing7,
    material: 'Color pencil',
    size: '20x30',
  },
  {
    imageSRC: drawing8,
    material: 'Color pencil',
    size: '20x30',
  },
  {
    imageSRC: drawing9,
    material: 'Color pencil',
    size: '20x30',
  },
  {
    imageSRC: drawing10,
    material: 'Color pencil',
    size: '20x30',
  },
  {
    imageSRC: drawing11,
    material: 'Color pencil',
    size: '20x30',
  },
  {
    imageSRC: drawing12,
    material: 'Color pencil',
    size: '20x30',
  },
  {
    imageSRC: drawing13,
    material: 'Color pencil',
    size: '20x30',
  },
  {
    imageSRC: drawing14,
    material: 'Color pencil',
    size: '20x30',
  },
  {
    imageSRC: drawing15,
    material: 'Color pencil',
    size: '20x30',
  },
  {
    imageSRC: drawing16,
    material: 'Color pencil',
    size: '20x30',
  },
  {
    imageSRC: drawing17,
    material: 'Color pencil',
    size: '20x30',
  },
  {
    imageSRC: drawing18,
    material: 'Color pencil',
    size: '20x30',
  },
  {
    imageSRC: drawing19,
    material: 'Color pencil',
    size: '20x30',
  },
  {
    imageSRC: drawing20,
    material: 'Color pencil',
    size: '20x30',
  },
  {
    imageSRC: drawing22,
    material: 'Color pencil',
    size: '20x30',
  },
  {
    imageSRC: drawing23,
    material: 'Color pencil',
    size: '20x30',
  },
  {
    imageSRC: drawing25,
    material: 'Color pencil',
    size: '20x30',
  },
  {
    imageSRC: drawing27,
    material: 'Color pencil',
    size: '20x30',
  },
  {
    imageSRC: drawing29,
    material: 'Color pencil',
    size: '20x30',
  },
  {
    imageSRC: drawing30,
    material: 'Color pencil',
    size: '20x30',
  },
  {
    imageSRC: drawing35,
    material: 'Soft pencil',
    size: 'Studio',
  },
  {
    imageSRC: drawing36,
    material: 'Soft pencil',
    size: '110x200',
  },
  {
    imageSRC: drawing37,
    material: 'Soft pencil',
    size: '110x200',
  },
  {
    imageSRC: drawing38,
    material: 'Soft pencil',
    size: '42x60',
  },
  {
    imageSRC: drawing40,
    material: 'Soft pencil',
    size: '42x60',
  },
  {
    imageSRC: drawing41,
    material: 'Soft pencil',
    size: '42x60',
  },
  {
    imageSRC: drawing42,
    material: 'Soft pencil',
    size: '110x200',
  },
  {
    imageSRC: drawing43,
    material: 'Soft pencil',
    size: '110x200',
  },
];
